import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";

// Pages
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import DroneHealthCheck from "./Pages/DroneHealthCheck";
import RepairM from "./Pages/RepairM";
import SmartFarming from "./Pages/SmartFarming";
import Helpdesk from "./Pages/Helpdesk";
import Sustainability from "./Pages/Sustainability";
import BlogSection from "./Pages/Blog";
import BlogDetail from "./Pages/BlogDetail";
import SchemaInjector from "./Components/SchemaMarkup/SchemaInjector";

export default function App() {
  return (
    <>
    <SchemaInjector/>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/sustainability" element={<Sustainability/>} />
        <Route path="/drone_health_check" element={<DroneHealthCheck />} />
                <Route path="/repair_and_maintenance" element={<RepairM/>} />
                <Route path="/smartfarming" element={<SmartFarming/>} />
                <Route path="/helpdesk" element={<Helpdesk/>} />
<Route path="/blog" element={<BlogSection/>} />
        <Route path="/blog-detail" element={<BlogDetail />} />
      </Routes>

      <Footer />
    </>
  );
}
